import { Line } from "react-chartjs-2";
import type { ChartData, ChartOptions } from "chart.js";
import {
  Chart as ChartJS,
  LineElement,
  CategoryScale,
  LinearScale,
  PointElement,
  Title,
  Tooltip,
  Legend,
  Filler,
} from "chart.js";
ChartJS.register(
  LineElement,
  CategoryScale,
  LinearScale,
  PointElement,
  Title,
  Tooltip,
  Legend,
  Filler
);

interface LineProps {
  options: ChartOptions<"line">;
  data: ChartData<"line">;
}

const Component = ({
  analytics,
  title,
  color,
  options,
}: {
  analytics?: any;
  title?: string;
  color?: string;
  options?: { plugins?: { [key: string]: any }; scales?: { x?; y? } };
}) => {
  const Props: LineProps = {
    options: {
      responsive: true,
      maintainAspectRatio: false,
      plugins: {
        datalabels: {
          display: false, // Hide point labels
        },
        legend: {
          position: "top",
        },
      },
      scales: {
        y: {
          min: 0,
          max: 5,
          ticks: {
            stepSize: 1,
          },
        },
        x: {
          ...(options?.scales?.x && options?.scales?.x),
        },
      },
    },
    data: {
      datasets: [
        {
          label: `${title ? title : "Crecimiento Global"}`,
          data: analytics.map((analytic) => analytic.note),
          borderColor: `${color ? color : "red"}`,
          backgroundColor: `${color ? color : "red"}`,
        },
      ],
      labels: analytics.map((analytic) => analytic.level),
    },
  };
  return <Line data={Props.data} options={Props.options} />;
};

export default Component;
